// ── MOBILE NAV HAMBURGER ──
const hamburger = document.getElementById('nav-hamburger');
const navLinks = document.querySelector('.nav-links');
if (hamburger && navLinks) {
  hamburger.addEventListener('click', () => {
    const open = navLinks.classList.toggle('open');
    hamburger.classList.toggle('open', open);
    hamburger.setAttribute('aria-expanded', open);
  });
  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      navLinks.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    });
  });
}

// ── SCROLL NAV ──
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  });
}

// ── SCROLL REVEAL ──
const reveals = document.querySelectorAll('.reveal');
if (reveals.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  reveals.forEach(el => observer.observe(el));
}

// ── CART DRAWER ──
class MeiyaCart {
  constructor() {
    this.drawer  = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.toggle  = document.getElementById('cart-toggle');
    this.countEl = document.getElementById('cart-count');
    this.body    = document.getElementById('cart-drawer-body');
    this.footer  = document.getElementById('cart-footer');
    this.subtotalEl = document.getElementById('cart-subtotal');

    if (!this.drawer) return;

    this.toggle?.addEventListener('click', () => this.open());
    this.overlay?.addEventListener('click', () => this.close());
    document.getElementById('cart-close')?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });

    this.fetchAndRender();
  }

  async fetchAndRender() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      this.renderItems(cart);
      this.updateBadge(cart.item_count);
    } catch (_) {}
  }

  updateBadge(count) {
    if (!this.countEl) return;
    this.countEl.textContent = count;
    this.countEl.style.display = count > 0 ? 'flex' : 'none';
    // Update nav checkout button behaviour based on cart state
    const checkoutBtn = document.getElementById('nav-checkout');
    if (checkoutBtn) {
      if (count === 0) {
        checkoutBtn.dataset.empty = 'true';
      } else {
        delete checkoutBtn.dataset.empty;
      }
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  renderItems(cart) {
    if (!this.body) return;

    if (cart.items.length === 0) {
      this.body.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="cart-continue">Continue Shopping →</a>
        </div>`;
      if (this.footer) this.footer.style.display = 'none';
      return;
    }

    this.body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-image">
          ${item.image ? `<img src="${item.image}" alt="${this.escape(item.product_title)}" loading="lazy">` : ''}
        </div>
        <div class="cart-item-details">
          <p class="cart-item-title">${this.escape(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item-variant">${this.escape(item.variant_title)}</p>` : ''}
          <div class="cart-item-qty">
            <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="cart-item-price">${this.formatMoney(item.line_price)}</div>
      </div>
    `).join('');

    if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    if (this.footer) this.footer.style.display = 'block';

    // Quantity buttons
    this.body.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const current = parseInt(btn.dataset.qty, 10);
        const qty = btn.dataset.action === 'increase' ? current + 1 : current - 1;
        await this.changeQty(key, qty);
      });
    });
  }

  async changeQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    this.fetchAndRender();
  }

  escape(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  open() {
    this.drawer?.classList.add('open');
    this.overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.fetchAndRender();
  }

  close() {
    this.drawer?.classList.remove('open');
    this.overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }
}

const meiyaCart = new MeiyaCart();

// ── NAV CHECKOUT: if cart empty, open cart drawer instead ──
document.getElementById('nav-checkout')?.addEventListener('click', (e) => {
  if (e.currentTarget.dataset.empty === 'true') {
    e.preventDefault();
    meiyaCart.open();
  }
});

// ── CART FORM (Add to Cart → open drawer) ──
const cartForm = document.querySelector('.product-form form');
if (cartForm) {
  cartForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = cartForm.querySelector('.btn-add-to-cart');
    const originalText = btn.textContent;
    btn.textContent = 'Added ✓';
    btn.style.background = 'var(--red-seal)';
    const formData = new FormData(cartForm);
    await fetch('/cart/add.js', { method: 'POST', body: formData });
    await meiyaCart.fetchAndRender();
    meiyaCart.open();
    setTimeout(() => {
      btn.textContent = originalText;
      btn.style.background = '';
    }, 1800);
  });
}

// ── REVIEW PAGE — star rating wires rating value into hidden field ──
const starRating = document.getElementById('star-rating');
const ratingInput = document.getElementById('rating-input');
if (starRating && ratingInput) {
  starRating.querySelectorAll('.star-input').forEach(radio => {
    radio.addEventListener('change', () => {
      ratingInput.value = radio.value;
    });
  });
}
